<template>
  <div id="centros">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex xs12 >
          <h4 class="grey--text text--darken-1">
            <v-icon small color="primary">drag_indicator</v-icon> Centros de Capacitación
          </h4>
        </v-flex>
      </v-layout>
      <v-card>
        <v-card-title class="headline lighten-3">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
          >
          </v-text-field>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark to="/centros/nuevo">Nuevo</v-btn>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :loading="loading"
          :items="centros"
          class="elevation-1"
          rows-per-page-text="Filas por página"
          no-data-text="No existen registros"
          no-results-text="Sin resultados"
          page-text="de"
          :rows-per-page-items="[10, 25, 50, 100, {'text': 'Todos', value: -1}]"
          v-bind:search="search"
          v-cloak
        >
          <template v-slot:items="props">
            <td>{{ props.index + 1 }}</td>
            <td>{{ props.item.id }}</td>
            <td>{{ props.item.institucioneducativa }}</td>
            <td>{{ props.item.nro_resolucion }}</td>
            <td>{{ props.item.fecha_creacion | formatdate }}</td>
            <td>
              <span v-if="props.item.estadoinstitucion_tipo_id == 10"><v-chip small color="success lighten-2">activo</v-chip></span>
              <span v-else-if="props.item.estadoinstitucion_tipo_id == 19"><v-chip small color="red lighten-2">cerrada</v-chip></span>
              <span v-else><v-chip small color="warning lighten-2">eliminada</v-chip></span>
            </td>
            <td>
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn
                    v-on="on"
                    dark
                    icon
                    small
                    depressed
                    color="primary"
                    @click="showDetail(props.item.id)"
                  >
                    <v-icon small>assignment</v-icon>
                  </v-btn>
                </template>
                <span>Ver detalle</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn
                    v-on="on"
                    dark
                    icon
                    small
                    depressed
                    color="red"
                    @click="formularioRcctp(props.item.id, props.item.tramite_id)"
                  >
                    <v-icon small>print</v-icon>
                  </v-btn>
                </template>
                <span>Imprimir RCCTP</span>
              </v-tooltip>
            </td>
            <!-- <td>
              <v-btn
                depressed
                icon
                dark
                color="red"
                small
                @click="confirmEliminado(props.item.id)"
              >
                <v-icon small>delete</v-icon>
              </v-btn>
            </td> -->
          </template>
        </v-data-table>
      </v-card>
    </v-container>
    <v-dialog
      v-model="dialogDetail"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <detalle-centro :mcentro="centro" :mcursos="cursos" :mcodigo="codigo_centro" :minfor="infor" :mloading="loadingDetail" @close="dialogDetail = false"></detalle-centro>
    </v-dialog>
    <v-dialog v-model="mconfirm" width="300">
      <v-card>
        <v-card-title class="headline grey lighten-3" primary-title>
          <span class="headline">Alerta</span>
        </v-card-title>
        <v-card-text class="text-xs-center">Esta seguro(a) de eliminar el registro?</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success darken-1" flat @click="deleteCentro()">
            Aceptar
          </v-btn>
          <v-btn color="blue darken-1" flat @click="mconfirm = false">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snack.state"
      top
      right
      :timeout="2500"
      :color="snack.color"
      :multi-line="snack.mode === 'multi-line'"
    >
      {{ snack.text }}
    </v-snackbar>
  </div>
</template>
<script>
/* eslint-disable no-console */
import Service from "../services/general";
import axios from "axios";
import DetalleCentro from '@/components/DetalleCentro';
import { format } from 'path';
export default {
  name: "centros",
  components: {
    DetalleCentro
  },
  data() {
    return {
      search: "",
      headers: [
        { text: 'Nro', align: 'left', sortable: false },
        { text: 'Código ', value: 'codigo' },
        { text: 'Centro de Capacitación ', value: 'institucioneducativa' },
        { text: "Número Resolución ", value: "nro_resolucion" },
        { text: 'Fecha Creación ', value: 'fecha_creacion' },
        { text: 'Estado ', value: 'estadoinstitucion_tipo_id' },
        { text: 'Acción', sortable: false, width: '145px' }
      ],
      headersCurso: [
        { text: 'Nro', align: 'left', sortable: false },
        { text: 'Código ', sortable: false },
        { text: 'Curso de Capacitación ', sortable: false },
        { text: 'Carga Horaria ', sortable: false },
        { text: 'Tiempo (1 mes) ', sortable: false }
      ],
      loading: false,
      loadingCentro: false,
      loadingDetail: false,
      infor: [],
      centros: [],
      cursos: [],
      size_width: 0,
      codigo_centro: '',
      centro: {
        jurisdiccion_geografica: {}
      },
      dialogDetail: false,
      mconfirm: false,
      snack: {
        state: false,
        color: 'success',
        mode: '',
        text: ''
      }
    };
  },
  mounted() {
    this.dparams = Service.getParams();
    if (this.dparams && this.dparams.roluser != Service.rol().nacional) {
      this.$router.push({name: 'principal'});
    }
    if (this.dparams != null) {
      this.getCentros();
    }
    this.$nextTick(() => {
      window.addEventListener("resize", this.getWidth);
      this.getWidth();
    });
  },
  methods: {
    getWidth() {
      this.size_width = document.documentElement.clientWidth;
    },
    getCentros() {
      this.loading = true;
      axios
        .get(Service.getBase() + 'lista/centros', Service.getHeader())
        .then(response => {
          this.loading = false;
          this.centros = response.data;
        })
        .catch(error => {
          this.loading = false;
          console.error("Error al cargar registros", error);
        });
    },
    confirmEliminado(centro_id) {
      this.centro.id = centro_id;
      this.mconfirm = true;
    },
    deleteCentro() {
      axios
        .delete(Service.getBase() + 'elimina/centro/' + this.centro.id, Service.getHeader())
        .then(() => {
          this.toast('success', 'Registro eliminado.');
          this.mconfirm = false;
          this.getCentros();
        })
        .catch(error => {
          console.error('Error al eliminar', error);
        });
    },
    showDetail(codigo) {
      this.codigo_centro = codigo;
      this.dialogDetail = true;
      this.loadingDetail = true;
      Service.detalleCentro(codigo).then(response => { 
        this.centro = response.data.centro;
        this.cursos = response.data.cursos;
        this.infor = response.data.infor;
        this.loadingDetail = false;
        this.drowMap(this.centro.jurisdiccion_geografica.cordy, this.centro.jurisdiccion_geografica.cordx, this.centro.institucioneducativa);
      }).catch(error => {
        this.loadingDetail = false;
        console.error('Error al cargar datos', error);
      });
    },
    formularioRcctp(ie_id, tramite_id) {
      //axios.get(Service.getBase() + 'tramite/imprime/1/'+ Service.getTramiteId()).then(response => {
      axios.post(Service.getBase() + 'centro/rcctp', {'ie_id': ie_id, 'tramite_id': tramite_id}, Service.getHeader()).then(response => {
        var datos = response.data;
        let propietario = datos.propietario ? datos.propietario.nombre+' '+datos.propietario.paterno+' '+datos.propietario.materno : '';
        let representante = datos.representante_legal ? datos.representante_legal.nombre+' '+datos.representante_legal.paterno+' '+datos.representante_legal.materno : '';
        var myDataCursos = [];
        //{text: 'N°', style: 'tableHeader', alignment: 'center', fillColor: '#e0e3e5', fontSize: 9.5}, 
        myDataCursos.push([{text: 'CURSOS DE CAPACITACIÓN', style: 'tableHeader'}, {text: 'RÉGIMEN DE ESTUDIOS', style: 'tableHeader'}, {text: 'CARGA HORARIA', style: 'tableHeader'}, {text: 'CERTIFICACIÓN', style: 'tableHeader'}]);
        for (const curso of datos.cursos) {
          myDataCursos.push([{text: curso.curso_nombre}, {text: 'Mensual', alignment: 'center'}, {text: curso.carga_horaria, alignment: 'center'}, {text: ''}]);
        }
        var docDefinition = {
          pageMargins: Service.pdfSetting().pMargin,
          pageSize: Service.pdfSetting().pSize,
          pageOrientation: Service.pdfSetting().pOrientation,
          defaultStyle : Service.pdfSetting().defStyle,
          header: Service.pdfSetting().myheaderF('RCCTP'),
          footer: Service.pdfSetting().myfooter,
          styles: Service.pdfSetting().mystyle,
          content: [
            { text: "DATOS GENERALES", bold : true, alignment: 'center', fontSize: 14, margin: [0, 15, 0, 6] },
            {
              columns: [
                {
                  width: "25%",
                  text: "NOMBRE/RAZÓN SOCIAL:",
                  bold : true,
                  margin: [0, 2, 0, 4],
                },
                {
                  width: "75%",
                  text: 'CENTRO DE CAPACITACIÓN TÉCNICA ' + datos.centro ? datos.centro.institucioneducativa : '',
                  margin: [0, 2, 0, 4],
                }
              ]
            },
            {
              columns: [
                {
                  width: "25%",
                  text: "DEPARTAMENTO:",
                  bold : true,
                  margin: [0, 4, 0, 4],
                },
                {
                  width: "48%",
                  text: datos.centro ? datos.centro.departamento : '',
                  margin: [0, 4, 0, 4],
                },
                {
                  width: "7%",
                  text: "NIT:",
                  bold : true,
                  margin: [0, 4, 0, 4],
                },
                {
                  width: "30%",
                  text: '000000000000',
                  margin: [0, 4, 0, 4],
                }
              ]
            },
            {
              columns: [
                {
                  width: "25%",
                  text: "SEDE CENTRAL Y/O SUBSEDE:",
                  bold : true,
                  margin: [0, 4, 0, 4],
                },
                {
                  width: "75%",
                  text: (datos.centro.sede_central==true) ? 'SEDE CENTRAL' : 'SUBSEDE',
                  margin: [0, 4, 0, 4],
                }
              ]
            },
            {
              columns: [
                {
                  width: "25%",
                  text: "DIRECCIÓN:",
                  bold : true,
                  margin: [0, 4, 0, 4],
                },
                {
                  width: "75%",
                  text: datos.centro.direccion,
                  margin: [0, 4, 0, 4],
                }
              ]
            },
            {
              columns: [
                {
                  width: "25%",
                  text: "ZONA:",
                  bold : true,
                  margin: [0, 4, 0, 4],
                },
                {
                  width: "75%",
                  text: datos.centro.zona,
                  margin: [0, 4, 0, 4],
                }
              ]
            },
            {
              columns: [
                {
                  width: "25%",
                  text: "PROPIETARIA/O - REPRESENTANTE LEGAL:",
                  bold : true,
                  margin: [0, 2, 0, 12],
                },
                {
                  width: "75%",
                  text: (propietario == representante ? propietario : propietario + ' / ' + representante_legal),
                  margin: [0, 2, 0, 12],
                }
              ]
            },
            { text: "DATOS TÉCNICOS", bold : true, alignment: 'center', fontSize: 14, margin: [0, 15, 0, 6] },
            {
              columns: [
                {
                  width: "25%",
                  text: "CURSOS AUTORIZADOS:",
                  bold : true,
                  margin: [0, 4, 0, 12],
                },
                {
                  width: "48%",
                  text: '',
                  margin: [0, 4, 0, 12],
                },
                {
                  width: "7%",
                  text: "AREA:",
                  bold : true,
                  margin: [0, 4, 0, 12],
                },
                {
                  width: "30%",
                  text: '-COMERCIAL-',
                  margin: [0, 4, 0, 12],
                }
              ]
            },
            {
              style: 'tableExample',
              table: {
                headerRows: 1,
                widths: ['35%','20%','15%','30%'],
                body: myDataCursos
              }
            },
            { text: "VIGENCIA", bold : true, alignment: 'center', fontSize: 14, margin: [0, 15, 0, 6] },
            {
              columns: [
                {
                  width: "25%",
                  text: "RESOLUCIÓN MINISTERIAL:",
                  bold : true,
                  margin: [0, 4, 0, 4],
                },
                {
                  width: "75%",
                  text: 'N° ' + datos.centro.nro_resolucion,
                  margin: [0, 4, 0, 4],
                }
              ]
            },
            {
              columns: [
                {
                  width: "25%",
                  text: "FECHA DE EMISIÓN:",
                  bold : true,
                  margin: [0, 4, 0, 4],
                },
                {
                  width: "30%",
                  text: datos.centro.fecha_resolucion.split('-').reverse().join('/'),
                  margin: [0, 4, 0, 4],
                },
                {
                  width: "25%",
                  text: "FECHA DE VENCIMIENTO:",
                  bold : true,
                  margin: [0, 4, 0, 4],
                },
                {
                  width: "20%",
                  text: datos.fecha_vencimiento.substring(0,10).split('-').reverse().join('/'),
                  margin: [0, 4, 0, 4],
                }
              ]
            },
            {
              stack: [
                { canvas: [{ type: 'line', x1: 360, y1: 50, x2: 190, y2: 50 }] },
                { text: 'VICIMINISTRO/A DE EDUCACIÓN\nALTERNATIVA Y ESPECIAL', bold : true, alignment: 'center', margin: [0, 4, 0, 0]},
              ]
            },
            { text: "EL PRESENTE DOCUMENTO DEBE SER EXHIBIDO EN LUGAR VISIBLE DEL CCTP", bold : true, alignment: 'center', fontSize: 9, margin: [0, 20, 0, 0] }
          ]
        };
        pdfMake.createPdf(docDefinition).open();
        // pdfMake.createPdf(docDefinition).download("FiltroNacional.pdf");
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    toast(color, text) {
      this.snack.color = color;
      this.snack.text = text;
      this.snack.state = true;
    },
    beforeDestroy() {
      window.removeEventListener("resize", this.getWidth);
    }
  }
};
</script>